export const translations = {
  siteName: '韩漫漫画网',
  siteTagline: '发现精彩韩漫世界',
  navHome: '首页',
  navCategory: '分类',
  navRanking: '排行榜',
  navLatest: '最新更新',
  navAbout: '关于我们',
  heroTitle1: '探索无限韩漫宇宙',
  heroTitle2: '免费阅读精彩故事每一刻',
  heroDesc: '海量韩国漫画 · 每日更新 · 高清画质 · 智能推荐',
  heroCtaStart: '开始阅读',
  heroCtaExplore: '探索分类',
  sectionHotRanking: '🔥 热门排行',
  sectionLatest: '📖 最新更新',
  sectionTestimonials: '💬 读者口碑',
  sectionCta: '🎯 现在就开始你的阅读之旅',
  ctaTitle: '加入百万读者',
  ctaDesc: '韩漫漫画网汇聚了最全的韩国漫画资源，从恋爱甜宠到热血冒险，从悬疑推理到治愈日常，总有一部适合你。免费在线阅读，无需注册，即刻享受。',
  ctaButton: '立即探索热门漫画',
  btnReadNow: '开始阅读',
  btnAddShelf: '加入书架',
  btnMore: '查看更多',
  tagNew: '新作',
  tagHot: '热门',
  tagCompleted: '已完结',
  tagOngoing: '连载中',
  labelAuthor: '作者',
  labelUpdate: '更新至',
  labelViews: '阅读量',
  labelFavorites: '收藏',
  labelRating: '评分',
  labelChapters: '章节',
  footerDesc: '韩漫漫画网 - 您的免费韩国漫画在线阅读平台。每日更新海量韩漫资源，智能推荐发现新喜好。',
  footerAddress: '地址',
  footerAddressVal: '中国北京市朝阳区漫画大厦 1008 室',
  footerPhone: '电话',
  footerPhoneVal: '+86 400-888-6666',
  footerEmail: '邮箱',
  footerEmailVal: 'hello@linxituan.com',
  footerCopyright: '© 2026 韩漫漫画网 版权所有',
  footerTerms: '服务条款',
  footerPrivacy: '隐私政策',
  footerContact: '联系我们',
  breadcrumbHome: '首页',
  categoryRomance: '恋爱甜宠',
  categoryAction: '热血冒险',
  categoryMystery: '悬疑推理',
  categoryHealing: '治愈日常',
  categoryFantasy: '奇幻异界',
  categoryDrama: '都市剧情',
  viewAll: '查看全部',
  testiTag: '读者评价',
  testiTitle1: '最懂我',
  testiTitle1Alt: '的韩漫平台',
  testiDesc1: '"自从发现了韩漫漫画网，我每天都要来这里看更新。画风精美，翻译质量高，最重要的是完全免费！推荐给所有喜欢韩漫的朋友。"',
  testiAuthor1: '小雨同学',
  testiTitle2: '更新超快',
  testiTitle2Alt: '体验一流',
  testiDesc2: '"更新速度真的太快了，几乎是同步更新。分类也很清晰，找漫画特别方便。下拉式阅读体验特别流畅，完全沉浸式看漫画。"',
  testiAuthor2: '漫画迷小王',
  testiTitle3: '资源最全',
  testiTitle3Alt: '值得推荐',
  testiDesc3: '"找了很久的冷门韩漫这里居然都有！智能推荐也特别准，推荐给我的几部漫画我全都爱上了。已经安利给身边所有朋友了。"',
  testiAuthor3: '阿琳爱看漫画',
};